export const filters = {
  getTags(val) {
    const tags = {
      1: '武器',
      2: '枪械',
      3: '工具',
      4: '装备',
      5: '玩具',
      6: '食物',
      7: '杂物',
      8: '人物',
      9: '动物',
      10: '怪物',
      11: '机器人',
      12: '建筑',
      13: '方块',
      14: '植物',
      15: '装饰物',
      16: '家具',
      17: '载具',
      18: '机械'
    };
    return (
      val &&
      val
        .split(',')
        .map(i => tags[i])
        .join(',')
    );
  },

  getSize(val) {
    const unitArr = new Array(
      'Bytes',
      'KB',
      'MB',
      'GB',
      'TB',
      'PB',
      'EB',
      'ZB',
      'YB'
    );
    let index = 0;
    const srcsize = parseFloat(val);
    index = Math.floor(Math.log(srcsize) / Math.log(1024));
    let size = srcsize / Math.pow(1024, index);
    size = size.toFixed(2); //保留的小数位数
    return size + unitArr[index];
  }
};

export default filters;
